require('./bootstrap');
require('bootstrap');
require('bootstrap-modal');
require('bootstrap-datepicker');
require('pc-bootstrap4-datetimepicker');
require('datatables.net-bs4');
require('jquery-mask-plugin');
import './Common/livewireCompat';

global.$ = global.jQuery = require('jquery');
window.Dropzone = require('dropzone');
window.Compressor = require('compressorjs');
Dropzone.autoDiscover = false;

import WindowManager from './Common/WindowManager';
window.WindowManager = WindowManager;

import masks from "./masks";

import product from "./product";
import customer from "./customer";
import order from "./order";
import category from "./category";
import auth from "./auth";
import dashboard from "./dashboard";
import table from "./table";
import employee from "./employee";
window.Employee = employee;
import errors from "./errors";
import settings from "./settings";
import incidents from './incidents';
import notepad from './notepad';
import admin_users from './admin/admin_users';
import articles from './admin/articles';
import uploads from './admin/uploads';
import users from "./users";
import refund from "./refund";
import services_management from "./organizations/services-management/services_management";
import phone_confirmation from "./phone_confirmation";

import time_management from './admin/time_management';
import worker_cabinet from "./worker_cabinet";
import vendors from './organizations/vendors-management/vendors';
import video_guides from "./admin/video_guides";
import event from "./admin/event";
import payments from "./payments/payments";
import { SideBar } from "./sidebar";
import service_list from "./services-list/service-list";
import features from "./features";
import price from "./price";
import faq from "./faq";
import { SideBarEvent } from "./Common/Events/Events";
import cockpitStatistics from "./organisations-cockpit/cockpit-statistics";
import preliminary_org from "./admin/preliminary_org";
import paymentSubscriptions from "./payment-subscriptions/payment-subscriptions";

import activity_logs from "./activity_logs";

import Slider from "./slider";
import snippetSettings from "./snippets/settings";
import RunningLine from "./components/RunningLine";
import { SimpleSectionSwitcher } from "./components/SimpleSectionSwitcher";

import manage_organisations from './admin/manage_organisations';
import LeadsManagement from './organizations/leads-management/leads';
import email_marketing from './admin/email_marketing/email_marketing';
// import individualJobs from './jobs-flow/individual-jobs';
// window.individualJobs = individualJobs;
import business_page from './business-pages/business_page';
import WorkersSelect from './components/WorkersSelect';
import QuickbooksIntegration from './organisation/quickbooks-integration';
//import FcmNotify from './fcm-notify';
import emailSettings from './organisations-cockpit/email-settings';
import FcmNotify from './fcm-notify';
import createOrganisation from './create-organisation';
import helpCenter from './static-pages/help-center';
import articlesManagement from './admin/articles-management';
import system_emails from './admin/email_marketing/system_emails';
import { ColorPicker } from './components/ColorPicker';
import team from './team';
import customer_modal from './stafter-table/customer_modal';
import daterangepicker from './daterangepicker';
import { UnversalModal } from './universal-modal/universal-modal';
import warningService from './warning-service';
import quickbooksResync from './organisation/quickbooks-resync';
import organisationGlobalSearch from './organisation/global-search';
import organisationSearchResults from './organisation/search-results';
import organisationSearchEntityModal from './organisation/search-entity-modal';
import cSelect from './snippets/components/c-select';
import entitySearch from './admin/entity_search';
import Common from './components/Common';
import { HasAttachments } from './CRUDs/abstracts/mixins/HasAttachments';
import { reportRecordOpeningError } from './Common/reportRecordOpeningError';
window.daterangepicker = daterangepicker;

/** Universal modal → User info tab; record context is intentionally omitted because info has no internal record view. */
window.openDeletedCustomerUniversalModal = function (customerId, contextEntityId, internalStep) {
    try {
        const id = parseInt(customerId, 10);
        if (!Number.isInteger(id)) {
            return;
        }
        let oid = contextEntityId;
        if (oid != null && oid !== '') {
            const parsed = parseInt(oid, 10);
            oid = Number.isInteger(parsed) ? parsed : null;
        } else {
            oid = null;
        }
        const step = (internalStep && typeof internalStep === 'string')
            ? internalStep.replace(/[^a-z0-9_-]/gi, '') || 'appointment'
            : 'appointment';
        const modal = new UnversalModal(id);
        modal.openModal('info', step);
    } catch (e) {
        console.error('openDeletedCustomerUniversalModal:', e);
    }
};

$.ajaxSetup({
    headers: {
        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
    }
});

$(document).ready(function () {

    // Demand-loaded page areas: webpack splits these into chunks that only
    // download on their own pages (same pattern as the Stripe/Maps imports).
    const bbPagePath = window.location.pathname;
    if (bbPagePath.startsWith('/email-department')) {
        import('./email-templating/email_templates').then(m => m.default.init());
        import('./email-templating/email-notifications').then(m => m.default.init());
        import('./email-templating/audience').then(m => m.default.init());
    }
    const emailBuilderRoot = document.querySelector('[data-email-builder-page]');
    if (emailBuilderRoot) {
        const emailBuilderPage = emailBuilderRoot.getAttribute('data-email-builder-page');
        if (emailBuilderPage === 'campaign-index' || emailBuilderPage === 'live-canvas') {
            import('./email-builder/live-canvas').then(m => m.default.init());
        } else if (emailBuilderPage === 'admin-block-editor') {
            import('./email-builder/admin-block-editor').then(m => m.default.init());
        } else if (emailBuilderPage === 'admin-block-list') {
            import('./email-builder/admin-block-list').then(m => m.default.init());
        } else if (emailBuilderPage === 'admin-mailable-list') {
            import('./email-builder/admin-mailable-list').then(m => m.default.init());
        } else if (emailBuilderPage === 'automation-email-layout') {
            import('./email-builder/automation-email-layout').then(m => m.default.init());
        }
    }
    if (bbPagePath.startsWith('/vehicles-management')) {
        import('./vehicles-mangement/vehicles-management').then(m => m.default.init());
        import('./vehicles-mangement/maintenance_report').then(m => m.default.init());
        import('./vehicles-mangement/accidents').then(m => m.default.init());
        import('./vehicles-mangement/invoices').then(m => m.default.init());
        import('./vehicles-mangement/alarms').then(m => m.default.init());
        import('./vehicles-mangement/repair_list').then(m => m.default.init());
    }
    if (bbPagePath.startsWith('/price-book')) {
        import('./price-book').then(m => m.default.init());
    }
    $(document).on('click', '.close-btn', function(e) {
        e.preventDefault();
        const url = new URL(window.location.href);
        const paramsToRemove = [
            'modal',
            'customer_id',
            'step',
            'internal_step',
            'parent_local_id',
            'entity_local_id',
        ];
        paramsToRemove.forEach(param => url.searchParams.delete(param));
        window.history.replaceState({}, '', url);
    });

    // Фикс скроллинга для загружаемых с сервера модалок
    new MutationObserver(function() {
        $(`body`).find('.modal').each(function () {
            $(this).off('hidden.bs.modal').on('hidden.bs.modal', () => {
                if ($('.modal.show').length>0) {
                    //console.log(".modal.show length>0");
                    $('body').addClass('modal-open')
                }else{
                    //console.log(".modal.show length<0");
                    $('body').removeClass('modal-open')
                }
            })
        })
    }).observe($(`body`)[0],{childList:true, subtree:true})

    // Check for universal modal state in URL parameters on page load
    const urlParams = new URLSearchParams(window.location.search);
    const modalType = urlParams.get('modal');
    const customerId = urlParams.get('customer_id');
    const step = urlParams.get('step');
    const supportedModalSteps = ['info', 'projects', 'appointments', 'subscriptions', 'overview'];
    const positiveInteger = (value) => /^[1-9]\d*$/.test(String(value ?? '').trim());
    // If we have the required parameters, open the universal modal
    if (modalType === 'universal' && positiveInteger(customerId) && supportedModalSteps.includes(step)) {
        // Delay the modal opening to ensure DOM is fully loaded
        setTimeout(() => {
            try {
                const modal = new UnversalModal(Number(customerId));
                const internalStep = urlParams.get('internal_step');
                const identifiers = {
                    parentLocalId: urlParams.get('parent_local_id'),
                    entityLocalId: urlParams.get('entity_local_id'),
                };

                if (internalStep && ['projects', 'appointments', 'subscriptions', 'overview'].includes(step)) {
                    modal.openModalFromUrl(step, internalStep, identifiers);
                } else {
                    modal.openModal(step, internalStep);
                }
            } catch (e) {
                console.error('Error opening universal modal from URL parameters:', e);
            }
        }, 1000);
    } else if (modalType === 'universal') {
        reportRecordOpeningError('This link contains invalid modal information.');
    }

    $(document).on('click', '.js-open-universal-modal-inline', function (e) {
        const href = $(this).attr('href');

        if (!href) {
            return;
        }

        let targetUrl;
        try {
            targetUrl = new URL(href, window.location.origin);
        } catch (error) {
            return;
        }

        const params = targetUrl.searchParams;
        const customerIdParam = params.get('customer_id');
        const customerId = positiveInteger(customerIdParam) ? Number(customerIdParam) : null;
        const step = params.get('step');
        const internalStep = params.get('internal_step');
        const identifiers = {
            parentLocalId: params.get('parent_local_id'),
            entityLocalId: params.get('entity_local_id'),
        };

        if (!customerId || !supportedModalSteps.includes(step)) {
            e.preventDefault();
            reportRecordOpeningError('This link contains invalid modal information.');
            return;
        }

        e.preventDefault();

        const openUniversalModal = () => {
            try {
                const modal = new UnversalModal(customerId);
                if (internalStep && ['projects', 'appointments', 'subscriptions', 'overview'].includes(step)) {
                    modal.openModalFromUrl(step, internalStep, identifiers);
                } else {
                    modal.openModal(step, internalStep);
                }
            } catch (error) {
                console.error('Error opening universal modal inline:', error);
                window.location.href = href;
            }
        };

        const parentModal = $(this).closest('.modal');
        if (parentModal.length && parentModal.hasClass('show')) {
            parentModal.one('hidden.bs.modal', () => {
                setTimeout(openUniversalModal, 150);
            });
            parentModal.modal('hide');
            return;
        }

        openUniversalModal();
    });

    $('[data-target=action-popup]').on('click', () => {
        $('.modal-window-actions').removeClass('d-flex');
        $('.modal-window-actions').addClass('d-none');
        $('[data-action-list-trigger]').removeClass('hover');
    });

    const showDropdownInOpenedSidebar = (dropdownSection, forced=false) => {

        if (dropdownSection.parents('.navbar').first().hasClass('navbar-vertical-right')) {
            const sideBar = $('.navbar-vertical-right').first();

            if (!sideBar.hasClass('opened') && !forced) {
                return;
            }
        } else {
            const sideBar = $('.navbar-vertical-left').first();

            if (!sideBar.hasClass('opened') && !forced) {
                return;
            }
        }
        console.log('next');

        const dropdownBtn = dropdownSection.find('.show-dropdown');
        if (dropdownBtn.hasClass('opened')) {
            dropdownBtn.removeClass('opened');
            dropdownSection.removeClass('opened');
        } else {
            dropdownBtn.addClass('opened');
            dropdownSection.addClass('opened');
        }
        dropdownBtn.parents('li').find('.dropdown').slideToggle();
    }

    const showDropdownInClosedSidebar = (sectionIcon) => {
        const section = sectionIcon.parents('li');
        const dropdown = section.find('.dropdown');
        const sidebar = $('.navbar-vertical-left');
        const mobile_sidebar = $('.navbar-vertical-right');

        if (/* sidebar.hasClass('opened') || */ mobile_sidebar.hasClass('show')) {
            return;
        }

        if (section.hasClass('visible')) {
            section.removeClass('visible');
            dropdown.removeClass('opened');
            sidebar.removeClass('only-dropdown');
        } else {
            section.addClass('visible');
            dropdown.addClass('opened');
            sidebar.addClass('only-dropdown');
        }

        sidebar.find('.dropdown').not(dropdown).removeClass('opened');
        mobile_sidebar.find('.dropdown').not(dropdown).removeClass('opened');
        sidebar.find('li').not(section).removeClass('visible');
        mobile_sidebar.find('li').not(section).removeClass('visible');
    }

    $('.dropdown-section').on('click', function() {
        if ($(this).parents('.navbar').hasClass('navbar-mobile')) {
            showDropdownInOpenedSidebar($(this));
        } else {
            showDropdownInClosedSidebar($(this).find('.icon'));
        }
        if ($(this).parents('li').hasClass('locked')) window.location = '/price';
    });
    $('.dropdown-section .icon').on('click', function() {
        //showDropdownInClosedSidebar($(this));
        if ($(this).parents('li').hasClass('locked')) window.location = '/price';
    });

    $('body').off('click', '.preview-ticket-link')
    .on('click', '.preview-ticket-link' ,function(ev) {
        let ticket = $(ev.currentTarget).attr('data-id');
        $.ajax({
            type: 'POST',
            url: `/admin/ticket-management/incident/${ticket}/preview`,
            success: (response) => {
                $('.preview-ticket-container').html(response);
                $('#ticket-preview-modal').modal('show');
            }
        });
    });

    if($('#incidents-cont').length){
        $.ajax({
            type: 'POST',
            url: `/admin/ticket-management`,
            success: (response) => {
                $('#website-section').html(response?.website);
                $('#mobile-section').html(response?.mobile);
                $('#main-preloader').removeClass('d-flex').addClass('d-none');
                window.refreshLivewireTree('#incidents-cont');
            },
            error: (xhr) => {
                const message = xhr?.responseJSON?.message || 'Unable to load ticket management.';
                $('#preloader-message').text(message);
                $('#main-preloader .bb-preloader-body').addClass('d-none');
            }
        });
    }

    $('#dropdown-call-menu').on('click', ev=>{
        ev.stopPropagation();
    })

    $('.open-sidebar').on('click', function() {

        const sideBar = $('.navbar-vertical-left').first();
        sideBar.removeClass('only-dropdown');
        if (sideBar.hasClass('opened')) {
            sideBar.removeClass('opened');
            $(this).find('span').text('>>');
            $('.sidebar-head').removeClass('opened');
            $('main').removeClass('compressed');

            for (let dropdownSection of $('.dropdown-section')) {
                dropdownSection = $(dropdownSection);
                const dropdown = dropdownSection.parents('li').find('.dropdown');
                if (dropdown.css('display') != 'none') {
                    showDropdownInOpenedSidebar(dropdownSection, true);
                }
            }
            //$(this).css('transform', 'translateX(0)');
        } else {
            sideBar.addClass('opened');
            $('.sidebar-head').addClass('opened');
            $('main').addClass('compressed');
            $(this).find('span').text('<<');
            //$(this).css('transform', 'translateX(176px)');
        }
        $.ajax({
            method: "POST",
            url: '/menu-visibility',
            success: () => {

            }
        });

        document.querySelector('.top-notifications').dispatchEvent(SideBarEvent);
    });

    $('.top-notifications').on('sidebar', (e) => {
        const topNotifications = $('.top-notifications');
        if (topNotifications.hasClass('compressed')) topNotifications.removeClass('compressed')
        else topNotifications.addClass('compressed');
    });

    $('#select_organisation').on('change', function() {
        $('#permission').val($('#select_organisation option:selected').data('permission'));
    })
    $('body').on('change', '#select_organisation', (e) => {
        if ($(e.currentTarget).val() == window.organisation_id) {
            $('#select-org-btn').attr('disabled', 'disabled');
        }else{
            $('#select-org-btn').removeAttr('disabled');
        }
    });

    /**
     * Client-side resize before /email-department/upload-image (2MB server limit).
     * Organisation logo: max height 50px, proportional width, keep format (no PNG→JPEG).
     * Other uploads pass options, e.g. background uses larger max dimensions.
     */
    function compressImageForEmailUpload(file, options) {
        const opts = options || {};
        const quality = opts.quality !== undefined ? opts.quality : 0.92;
        const maxWidth = opts.maxWidth !== undefined ? opts.maxWidth : 10000;
        const maxHeight = opts.maxHeight !== undefined ? opts.maxHeight : 50;

        return new Promise((resolve) => {
            // GIF excluded: Canvas API destroys animation (reads first frame only) and
            // cannot output GIF format, so skip compression for animated/transparent GIFs.
            if (!file || !/^image\/(jpeg|jpg|png)$/i.test(file.type)) {
                resolve(file);
                return;
            }
            new Compressor(file, {
                quality,
                maxWidth,
                maxHeight,
                success: (result) => {
                    resolve(new File([result], result.name, { type: result.type }));
                },
                error: () => resolve(file),
            });
        });
    }

    $('body').on('change','input#logo_img',function () {
        if ($('#logo_img').val() == '') {
            $('#logo_img_label').css('border-color', 'red');
            return;
        }
        $('#logo_img_label').css({'border-color': ''});

        const directory = 'email-templates';
        const form = $('#upload_logo_img_form')[0];
        const rawFile = this.files && this.files[0];
        if (!rawFile) {
            return;
        }

        compressImageForEmailUpload(rawFile).then((file) => {
            const data = new FormData();
            data.append('upload_image', file, file.name);
            data.append('directory', directory);
            $.ajax({
                type: 'POST',
                url: '/email-department/upload-image',
                data: data,
                enctype: 'multipart/form-data',
                processData: false,
                contentType: false,
                success: function(response) {
                    const previewUrl = location.protocol + "//" + location.host + response;
                    $('#logo-file-name').text(file.name);
                    $('#logo_img_label').text('Choose another image');
                    $('#logo_img').attr('value',response)
                    $('#logo-preview').attr('src', previewUrl)
                    $('#logo-preview-container').removeClass('d-none').addClass('d-flex')
                    $('#email_frame').contents()
                        .find('#header-logo, .organisation-logo')
                        .attr('src', previewUrl)
                        .css('display', '')
                    $('#email-logo-wide, #email-header-name-visible').first().trigger('change')
                },
                error: function(response) {
                    $(form).find('.error').html('');
                    if (response.responseJSON && response.responseJSON.errors && response.responseJSON.errors.upload_image) {
                        const errors = Object.values(response.responseJSON.errors);
                        errors[0].forEach(element => {
                            $(form).find('.error').removeClass('d-none').append(`<div class="my-2">${element}</div>`);
                        });
                    }
                    setTimeout(() => {
                        $(form).find('.error').addClass('d-none')
                    }, 3000);
                }
            });
        });
    })
    $('body').on('change','input#background_img',function() {
        if ($('#background_img').val() == '') {
            return;
        }
        const directory = 'organisation-background';
        const form = $('#upload_background_img_form')[0];
        const rawFile = this.files && this.files[0];
        if (!rawFile) {
            return;
        }

        compressImageForEmailUpload(rawFile, { maxWidth: 1600, maxHeight: 1600 }).then((file) => {
            const data = new FormData();
            data.append('upload_image', file, file.name);
            data.append('directory', directory);
            $.ajax({
                type: 'POST',
                url: '/email-department/upload-image',
                data: data,
                enctype: 'multipart/form-data',
                processData: false,
                contentType: false,
                success: function(response) {
                    $('#background_img_label').text(file.name);
                    $('#background_img').attr('value',response)
                    $('#background-preview').attr('src',location.protocol + "//" + location.host+response)
                    $('#background-preview-container').removeClass('d-none').addClass('d-flex')
                },
                error: function(response) {
                    $(form).find('.error').html('');
                    if (response.responseJSON && response.responseJSON.errors && response.responseJSON.errors.upload_image) {
                        const errors = Object.values(response.responseJSON.errors);
                        errors[0].forEach(element => {
                            $(form).find('.error').removeClass('d-none').append(`<div class="my-2">${element}</div>`);
                        });
                    }
                    setTimeout(() => {
                        $(form).find('.error').addClass('d-none')
                    }, 3000);
                }
            });
        });
    });

    $('body').off('click','#delete-logo').on('click','#delete-logo', (e)=>{
        let data = new FormData();
        data.append('directory', 'email-templates');
        $.ajax({
            type: 'POST',
            url: '/email-department/delete-image',
            data: data,
            enctype: 'multipart/form-data',
            processData: false,
            contentType: false,
            success: function(response) {
                if(response.success){
                    $('#logo_img').attr('value','')
                    $('#logo-preview').attr('src','')
                    $('#logo-preview-container').removeClass('d-flex').addClass('d-none')
                    $('#logo-file-name').text('No logo selected')
                    $('#logo_img_label').text('Choose image')
                    $('#email_frame').contents()
                        .find('#header-logo, .organisation-logo')
                        .attr('src', '')
                        .css('display', 'none')
                    $('#email-logo-wide, #email-header-name-visible').first().trigger('change')
                }
            },
            error: function(resp) {
                console.log(response);
                $('.error-log').text(resp.responseJSON.message);
            }
        });
    })

    $('body').off('click','.notify-item[data-notify-type]').on('click','.notify-item[data-notify-type]',(e)=>{
        let notify = $(e.currentTarget)
        let type = notify.data('notify-type')
        let id = notify.data('id')
        switch(type){
            case 'customer':
                if(!['/customers'].includes(window.location.pathname))
                    window.location='/customers'
                break;
        }
    })

    $('body').off('click','#delete-background').on('click','#delete-background',(e)=>{
        let data = new FormData();
        data.append('directory', 'organisation-background');
        $.ajax({
            type: 'POST',
            url: '/email-department/delete-image',
            data: data,
            enctype: 'multipart/form-data',
            processData: false,
            contentType: false,
            success: function(response) {
                if(response.success){
                    $('#background_img').attr('value','')
                    $('#background-preview').attr('src','')
                    $('#background-preview-container').removeClass('d-flex').addClass('d-none')
                    $('#background_img_label').text('Select image')
                }
            },
            error: function(resp) {
                console.log(response);
                $('.error-log').text(resp.responseJSON.message);
            }
        });
    })

    $('.apply-code-btn').click(function (e) {
        e.preventDefault();
        $.ajax({
            method: 'POST',
            url: '/apply-code',
            data: {
                promo_code: $('#promo_code').val(),
            },
            success: (response) => {
                if (response.error) {
                    $('.error-container').find('.error-text').text(response.error);
                    $('.error-container').removeClass('d-none');
                }else if(response.message){
                    $('.error-container').addClass('d-none');
                    $('.form-container').html(`<p class="text-center">${response.message}</p>`);
                }
            }
        });
    });

    $('#promo_code').on('input', function(e) {
        let submitButton = $(this).parents('form').find("button[type='submit']");
        /* if ($(this).val().length==3 && $(this).val() == "BB-") {

            $('#promo_code').inputmask('remove').inputmask({
                mask: "*{1,80}",
                greedy: false,
                definitions: {
                    '*': {
                      validator: "[0-9A-Za-z_\-]",
                      casing: "upper"
                    }
                }
            });
            } else if($(this).val().length==3 && $(this).val() !== "BB-") {

            $('#promo_code').inputmask('remove').inputmask({
                mask: "AAAA-AAAA-AAAA-AAAA",
                greedy: false,
                definitions: {
                    'A': {
                      validator: "[0-9A-Za-z]{0,1}",
                      casing: "upper"
                    }
                },
                placeholder: 'XXXX-XXXX-XXXX-XXXX'
            });
        } */

        if ($(this).val() == "") {
            $(this).removeClass('border-danger');
            $('.code-status').text('');
            submitButton.attr('disabled', false);
        }else{
            $.ajax({
                method: 'POST',
                url: 'admin/promo-codes/check-code',
                data: {
                    name: $(this).val(),
                },
                success: (response) => {
                    if (response == true) {
                        $('.code-status').text('Great! Your Code worked!').css('color', '#E4A947');
                        $(this).removeClass('border-danger').css('border-color', '#E4A947');
                        submitButton.attr('disabled', false);
                    }else{
                        $('.code-status').text('Oops! Code didn\'t match!').css('color', '#DB3A57');
                        $(this).addClass('border-danger');
                        submitButton.attr('disabled', true);
                    }
                },
                error: (response) => {
                    $('.code-status').text('Oops! Code didn\'t match!').css('color', '#DB3A57');
                    $(this).addClass('border-danger');
                    submitButton.attr('disabled', true);
                }
            })
        }
    });

    $('body').off('click', '.bug-programm-info-btn').on('click', '.bug-programm-info-btn', (e) => {
        e.preventDefault();
        $('#bug-programm-info-modal').modal('show');
    });
    $('.copy-element').click((e) => {
        e.preventDefault();
        const link_elem = $(e.currentTarget).data('target');
        const link = $(link_elem).text();
        if (navigator.clipboard && window.isSecureContext) {
            navigator.clipboard.writeText(link);
        } else {
            const textArea = document.createElement("textarea");
            textArea.textContent = link;
            
            // Move textarea out of the viewport so it's not visible
            textArea.style.position = "absolute";
            textArea.style.left = "-999999px";
            
            
            document.body.prepend(textArea);
            textArea.select();

            try {
                document.execCommand('copy');
            } catch (error) {
                console.error(error);
            } finally {
                textArea.remove();
            }
        }
    });

    function setCookie(name, value, days = 7) {
        let d = new Date();
        d.setTime(d.getTime() + (days * 24 * 60 * 60 * 1000));
        document.cookie = name + '=' + value + '; expires=' + d.toUTCString() + '; path=/; SameSite=Strict;';
    }
    window.setCookie = setCookie;

    product.init();
    customer.init();
    order.init();
    category.init();
    auth.init();
    dashboard.init();
    table.init();
    employee.init();
    errors.init();
    settings.init();
    // chat.init();
    incidents.init();
    //demo_incidents.init();
    notepad.init();
    admin_users.init();
    articles.init();
    uploads.init();
    users.init();
    refund.init();
    worker_cabinet.init();
    time_management.init();
    event.init();
    services_management.init();
    payments.init();
    let serviceList = new service_list();
    features.init();
    price.init();
    faq.init();
    video_guides.init()
    paymentSubscriptions.init();
    cockpitStatistics.init();
    activity_logs.init();
    masks.init();
    Slider.init();
    phone_confirmation.init();
    snippetSettings.init();
    RunningLine.init();
    SimpleSectionSwitcher.init();
    manage_organisations.init();
    email_marketing.init();
    // individualJobs.init();
    business_page.init();
    if (location.pathname.includes('/leads')) {
        let leads = new LeadsManagement();
    }
    vendors.init();
    WorkersSelect.init();
    QuickbooksIntegration.init();
    emailSettings.init();
    createOrganisation.init();
    helpCenter.init();
    articlesManagement.init();
    ColorPicker.init();
    team.init();
    customer_modal.init();
    warningService.init();
    quickbooksResync.init();
    organisationGlobalSearch.init();
    organisationSearchResults.init();
    organisationSearchEntityModal.init();
    system_emails.init();
    FcmNotify.init();
    cSelect.init();
    entitySearch.init();
    preliminary_org.init();
    Common.init();

    // A DEFAULT binding for `.upload-files`, so a trigger works on pages that never bound one.
    //
    // The listener resolves the entity and id from the trigger's own data attributes, so a
    // single global binding is what it was built for — but historically every page bound its
    // own copy with its own callback, and pages that bound none (the appointments and jobs
    // lists among them) had inert upload buttons. This runs LAST and uses .off() first, exactly
    // as every other caller does, so any page that binds afterwards still wins: behaviour where
    // a binding already exists is unchanged, and where none existed the button now opens the
    // dialog instead of doing nothing.
    if (typeof HasAttachments?.scopeOpenDropZoneListener === 'function') {
        HasAttachments.scopeOpenDropZoneListener();
    }
});
